import { createAction, props } from '@ngrx/store';

export const loadNotifications = createAction('[Notifications] Load Notifications', props<{ request: any }>());

export const loadNotificationsSuccess = createAction('[Notifications] Load Notifications Success', props<{ response: any }>());

export const loadNotificationsFailure = createAction('[Notifications] Load Notifications Failure', props<{ error: Error | any }>());
